module.exports = __webpack_public_path__ + "static/media/Formato_Cargar_Calificaciones_Transportistas_v3.cb5c3a97.xlsx";